import React from "react";
import { Form } from "sc/ui/components/Form";
import formWithMessages from "sc/ui/components/hoc/formWithMessages";

export const ERROR_BAD_FORMAT_CONTACT_EMAIL = "contact_email_bad_format";
export const ERROR_SOMETHING_WENT_WRONG = "something_went_wrong";

const validateEmail = candidate => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (!re.test(String(candidate).toLowerCase()))
    return ERROR_BAD_FORMAT_CONTACT_EMAIL;
  return undefined;
};

export default formWithMessages(props => {
  const { globalSettings, onSave, disabled } = props;
  return (
    <Form
      formProps={{
        id: `global-settings-form`,
        horizontal: true,
      }}
      onSubmit={onSave}
      {...props.messagesProps}
      fields={{
        adminContactName: {
          uiProps: {
            type: "text",
            placeholder: "Admin Contact Name",
            autoFocus: true,
            maxLength: 100,
          },
          position: 1,
          initialValue: globalSettings.adminContactName,
          label: "Admin Contact Name ",
          hoverHelp: () =>
            "Enter the name of the shift schedule manager here. This will appear on the Contact page for your employees.",
        },
        adminContactEmail: {
          uiProps: {
            type: "text",
            placeholder: "Admin Contact Email",
            autoFocus: true,
            maxLength: 100,
          },
          position: 2,
          initialValue: globalSettings.adminContactEmail,
          label: "Admin Contact Email ",
          hoverHelp: () =>
            "Enter the email address of the shift schedule manager here. This will appear on the Contact page for your employees.",
        },
      }}
      validation={formData => {
        if (formData.adminContactEmail)
          return validateEmail(formData.adminContactEmail);
        return undefined;
      }}
      submitButtonProps={{
        disabled,
        children: "Save",
        bsStyle: "primary",
      }}
      errorMessages={{
        [ERROR_BAD_FORMAT_CONTACT_EMAIL]:
          "The email address entered is invalid, please enter a new email address!",
        [ERROR_SOMETHING_WENT_WRONG]: "Something went wrong please try again!",
      }}
    />
  );
});



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/components/forms/GlobalSettings.js